import React, { Component } from 'react';

export class Footer extends Component {
  render () {
    return (
      <div className="footer1">
        <p className="mx-2" style={{fontSize: "12px"}}>
            The data relating to real estate for sale on this limited electronic display come in part from the Broker Reciprocity Program (BR Program) of StellarMLS. Properties listed with brokerage firms other than Palm Island Specialist are marked with the BR Program Icon or the BR House Icon and detailed information about them includes the name of the Listing Brokers. The properties displayed may not be all the properties available through the BR Program.
            Some properties that appear for sale on this website may no longer be available. For the most current information, contact Palm Island Specialist. Real estate data refreshed every hour.
        </p>
        <p className="text-center">
            All Rights Reserved. Licensed in Florida.
            <span>&nbsp;|&nbsp;</span>
            ©2019 Palm Island Specialist
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.jsx